import React from "react";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import { ThemeProvider, Tooltip } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import PropTypes from "prop-types";


const RemainderTriggerButton = ({ notifications }) => {
    const { headerTheme } = useJumboHeaderTheme();

    const unreadNotifications = notifications?.filter(
        (opt) => opt?.Open_flg === false
    )?.length || 0;

    let filterItems;
    if (unreadNotifications > 0) {
        if (unreadNotifications > 9) {
            filterItems = "9+";
        } else {
            filterItems = unreadNotifications;
        }
    }

    return (
        <ThemeProvider theme={headerTheme}>
            <JumboIconButton badge={{ variant: "standard" }} elevation={25} filterItems={filterItems}>
                <Tooltip title="Notifications" placement="top-start">
<NotificationsOutlinedIcon sx={{ fontSize: 22 }} />           
     </Tooltip>

            </JumboIconButton>
        </ThemeProvider>
    );
};

RemainderTriggerButton.propTypes = {
    notifications: PropTypes.number.isRequired,
};

export default RemainderTriggerButton